import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, booleanAttribute, input } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'a[ui-m010-c025-icon-link-external], button[ui-m010-c025-icon-link-external]',
    exportAs: 'iconLinkExternal',
    standalone: true,
    imports: [NgClass],
    templateUrl: './m010-c025-icon-link-external.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class M010C025IconLinkExternalComponent {
    white = input(false, { transform: booleanAttribute });
}
